import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

const debug = require('debug')('fifi:main');

export class MainController {

  /*@ngInject*/
  // constructor() {
  // }
}

export default angular.module('parkingFormApp.main', [uiRouter])
  .config(routing)
  .component('main', {
    template: require('./main.html'),
    controller: MainController,
    controllerAs: '$main',
    bindings: {
      settings: '<',
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js